<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>
<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
    <input type="number" #field class="form-control" [id]="(id === null ? name : id)" [name]="name" [value]="value"
        [disabled]="readOnly" [step]="step" (input)="changeValue($event, false, false, true)" (keyup)="pressKey($event)"
        pattern="[0-9]+([\.,][0-9]+)?" />
</ng-template>
<ng-template #showSpan>
    <span type="text" #field [id]="(id === null ? name : id)">
        {{value}}
    </span>
    <hr *ngIf="includeLabel" />
</ng-template>

<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
</div>
